// extracted by mini-css-extract-plugin
export default {"main":"PoweredBy_main__7tKyX","poweredby":"PoweredBy_poweredby__Gf6V8"};